// extracted by mini-css-extract-plugin
export default {"header":"styles_header__0nggV","header_data":"styles_header_data__VJMbq","name":"styles_name__+L-Ge"};